/* eslint-disable tsdoc/syntax */
/**
 * Singleton class for managing WebSocket connections and message listeners.
 * Provides centralized management of WebSocket instances and their associated message handlers.
 *
 * @example
 * const manager = WebSocketManager.getInstance()
 * const ws = manager.createConnection('chat', 'wss://example.com/chat')
 *
 * manager.addMessageListener('chat', (message) => {
 *   console.log('Received:', message)
 * })
 *
 * // Later:
 * manager.closeConnection('chat')
 */
export class WebSocketManager {
  constructor() {
    this.connections = new Map();
    this.listeners = new Map();
  }
  static getInstance() {
    if (!this.instance) {
      this.instance = new WebSocketManager();
    }
    return this.instance;
  }
  getConnection(key) {
    return this.connections.get(key);
  }
  addMessageListener(key, listener) {
    if (!this.listeners.has(key)) {
      this.listeners.set(key, new Set());
    }
    this.listeners.get(key).add(listener);
  }
  removeMessageListener(key, listener) {
    var _a;
    (_a = this.listeners.get(key)) === null || _a === void 0 ? void 0 : _a.delete(listener);
  }
  createConnection(key, url) {
    if (!this.connections.has(key)) {
      const ws = new WebSocket(url);
      ws.onmessage = event => {
        var _a;
        (_a = this.listeners.get(key)) === null || _a === void 0 ? void 0 : _a.forEach(listener => {
          try {
            const data = JSON.parse(event.data);
            listener(data);
          } catch (_a) {
            // Ignore non-JSON messages (like pong)
          }
        });
      };
      this.connections.set(key, ws);
      return ws;
    }
    return this.connections.get(key);
  }
  closeConnection(key) {
    const ws = this.connections.get(key);
    if (ws) {
      ws.close();
      this.connections.delete(key);
      this.listeners.delete(key);
    }
  }
}